import { __makeTemplateObject } from "tslib";
import styled from '@marvelapp/styled';
export var PencilWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 5px;\n  right: -20px;\n  padding-left: 5px;\n  opacity: 0;\n  transition-duration: 150ms;\n"], ["\n  position: absolute;\n  top: 5px;\n  right: -20px;\n  padding-left: 5px;\n  opacity: 0;\n  transition-duration: 150ms;\n"])));
var templateObject_1;
